import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const KeepsakeIcon: React.FC<OneColorIconProps> = ({ size = 24, color = 'white', className }) => {
  const hex = getHexColor(color)
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 21.6C3.45 21.6 2.97917 21.4042 2.5875 21.0125C2.19583 20.6208 2 20.15 2 19.6V7.6C2 7.05 2.19583 6.57917 2.5875 6.1875C2.97917 5.79583 3.45 5.6 4 5.6H8L11.3 2.3C11.5 2.1 11.7333 2 12 2C12.2667 2 12.5 2.1 12.7 2.3L16 5.6H20C20.55 5.6 21.0208 5.79583 21.4125 6.1875C21.8042 6.57917 22 7.05 22 7.6V19.6C22 20.15 21.8042 20.6208 21.4125 21.0125C21.0208 21.4042 20.55 21.6 20 21.6H4ZM4 19.6H20V7.6H4V19.6ZM11.25 16.6L9.4 14.125C9.3 13.9917 9.16667 13.925 9 13.925C8.83333 13.925 8.7 13.9917 8.6 14.125L6.6 16.8C6.46667 16.9667 6.45 17.1417 6.55 17.325C6.65 17.5083 6.8 17.6 7 17.6H17C17.2 17.6 17.35 17.5083 17.45 17.325C17.55 17.1417 17.5333 16.9667 17.4 16.8L14.65 13.125C14.55 12.9917 14.4167 12.925 14.25 12.925C14.0833 12.925 13.95 12.9917 13.85 13.125L11.25 16.6ZM8 12.6C8.41667 12.6 8.77083 12.4542 9.0625 12.1625C9.35417 11.8708 9.5 11.5167 9.5 11.1C9.5 10.6833 9.35417 10.3292 9.0625 10.0375C8.77083 9.74583 8.41667 9.6 8 9.6C7.58333 9.6 7.22917 9.74583 6.9375 10.0375C6.64583 10.3292 6.5 10.6833 6.5 11.1C6.5 11.5167 6.64583 11.8708 6.9375 12.1625C7.22917 12.4542 7.58333 12.6 8 12.6ZM10.1 5.6H13.9L12 3.7L10.1 5.6Z"
        fill={hex}
      />
    </svg>
  )
}
